import { useApolloClient, useQuery } from '@apollo/client';
import { useIsAuthenticated } from '@azure/msal-react';
import ErrorPage from './components/error-page';
import { GET_SECURITY_PROFILE } from './graphql/auth-gql';
import Router from './router';
import { AuthContext } from './services/auth/auth-context';
import { ISecurityProfileResponse } from './types/auth';
import SpinnerOverlay from './components/common/spinner/spinner';
import { Dispatch, useEffect, useMemo, useReducer, useState } from 'react';
import { ORG_VALUE_LISTS } from './graphql/valuelist-gql';
import { announce } from './services/env';
import { IOrgValueListsResponse, IValueList, IValueListLight } from './types/valuelist';
import React from 'react';
import { FrenchAction, FrenchContext, FrenchState, frenchReducer } from './components/french/french-context';

const Authed = () => {
    const { loading: loadingProfile, error, data: profileData } = useQuery<ISecurityProfileResponse>(GET_SECURITY_PROFILE);

    const isAuthenticated = useIsAuthenticated();
    const [appReady, setAppReady] = useState<boolean>(false)

    const client = useApolloClient();
    const { loading: loadingVL, data: orgValueListData } = useQuery<IOrgValueListsResponse>(ORG_VALUE_LISTS)
    const initialFrenchState: FrenchState = {
        isFrenchChecked: false,
      };

    const [state, dispatch] = useReducer(frenchReducer, initialFrenchState);
    const contextValue =  useMemo(() => [state, dispatch] as [FrenchState, Dispatch<FrenchAction>], [state]);
    useEffect(() => {
        if (orgValueListData) {
            announce(orgValueListData.orgValueLists.announcement)

            let orgTypes = orgValueListData.orgValueLists.orgTypes
            const modifiedData = {
                ...orgValueListData,
                orgValueLists: {
                    ...orgValueListData.orgValueLists,
                    topOrgTypeMap: buildOrgTypeMap(orgTypes, true),
                    orgTypeMap: buildOrgTypeMap(orgTypes, false)
                }
            };

            client.writeQuery({
                query: ORG_VALUE_LISTS,
                data: modifiedData
            })
        }

        if (profileData && orgValueListData) {
            setAppReady(true)
        }

    }, [profileData, orgValueListData])

    const buildOrgTypeMap = (orgTypes: IValueList[], topLevel: boolean) => {
        let orgTypeMap = new Map<number, IValueListLight[]>()
        orgTypes.forEach(o => {
            if (!orgTypeMap.has(o.parentId)) {
                orgTypeMap.set(o.parentId, [])
            }
            if ((topLevel && o.levelNum === 1) || (!topLevel && o.levelNum !== 1)) {
                orgTypeMap.get(o.parentId)?.push({
                    id: o.id,
                    type: o.type,
                    code: o.code,
                    label: o.label,
                    label2: o.label2
                })
            }
        })
        return orgTypeMap
    }

    if (loadingProfile || loadingVL) return <SpinnerOverlay />;
    if (error && !isAuthenticated) return <ErrorPage>{error.message}</ErrorPage>;

    return (
        <>
        { appReady &&
            <AuthContext.Provider value={profileData!.securityProfile}>
                <FrenchContext.Provider value={contextValue}>
                <Router />
                </FrenchContext.Provider>
            </AuthContext.Provider>
        }
        </>
    );
}

export default Authed
